import Vue from 'vue'
import Vuex from 'vuex'
import VueJsonp from 'vue-jsonp'

import Auth from './modules/auth'
import Role from './modules/role'
import Staff from './modules/staff'
import StaffPosition from './modules/staffPosition'
import Clinics from './modules/clinics'
import Visit from './modules/visit'
import Level from './modules/level'
import Object from './modules/object'
import Log from './modules/log'
import Loading from './modules/loading'
import Kpi from './modules/kpi'
import PropertyType from './modules/propertyType'
import DeactivationReason from './modules/deactivationReason'
import Specialization from './modules/specialization'
import ShopEmployeePosition from './modules/shopEmployeePosition'
import LogServer from './modules/logServer'
import PollQuests from './modules/pollQuests'
import PollTemplates from './modules/pollTemplates'
import Report from './modules/report'
import Competitor from './modules/competitor'
import Dobd from './modules/dobd'
import Account from './modules/account'
import Programs from './modules/programs'
import ProgramStatus from './modules/programStatus'
import PollTemplateActions from './modules/pollTemplateActions'
import PollsRunProgram from './modules/pollsRunProgram'
import ProgramList from './modules/programList'
import Cities from './modules/cities'
import EmailTemplate from './modules/emailTemplate'
import EmailSignatureTemplate from './modules/emailSignatureTemplate'
import Property from './modules/property'
import QuestionProperty from './modules/questionProperty'
import QuestionAnswers from './modules/questionAnswers'
import VisitType from './modules/visitType'
import Exhibition from './modules/exhibition'
import DataType from './modules/dataType'
import Dashboard from './modules/dashboard'
import AccountAppVersion from './modules/accountAppVersion'
import Countries from './modules/countries'
import Regions from './modules/regions'
import Employees from './modules/employees'
import EmployeeEmployments from './modules/employeeEmployments'
import AppVersions from './modules/appVersions'
import AppSettings from './modules/appsettings'
import TemplatesSms from './modules/templatesSms'
import POSM from './modules/posm'
import DevAppConfig from '../../static/data/appconfig.dev.json';
import ProdAppConfig from '../../static/data/appconfig.prod.json';

// Выбор конфигурации окружения при сборке:
// prod -> appconfig.prod.json, test/dev -> appconfig.dev.json
const AppEnvironmentConfig = process.env.APP_ENV === 'prod' ? ProdAppConfig : DevAppConfig;
import CommonConfig from '../../static/data/common.appconfig.json';
import Logging from './modules/logging'
import paths from '../router/paths'
import event from '../event'
import UserStatus from './modules/userStatus'

Vue.use(Vuex)
Vue.use(VueJsonp);

/*const localSetting = 0; // 1 - prod

let environment = !location.pathname.includes('test') ? 'Production' : 'Test';
let url = '#'; 
let netUrl = '#';


switch (localSetting) {
  case -1:
    environment = 'Local';

    // Для работы на локальном сервере 
    url = 'http://yii2-api-poh:8081/v1/';
    netUrl = 'https://localhost:4433/api'; // Локальный контроллер web.api

    break;
  case 1:
    environment = 'Test';

    // Для работы с тестовым API
    url = 'https://poh-api-test.adv-ant.ru/v1/';
    netUrl = 'https://services.adv-ant.ru/api-test'; // Контроллер web.api на web.magnat

    break;
  default:
    // Для работы на внешнем сервере 
    url = 'https://poh-api.adv-ant.ru/v1/';
    netUrl = 'https://services.adv-ant.ru/api'; // Контроллер web.api на web.magnat

    break;
}*/

const store = new Vuex.Store({
  namespaced: true,

  state: {
    version: CommonConfig.VUE_APP_VERSION,
    environment: AppEnvironmentConfig.VUE_APP_ENVIRONMENT,
    appLabel: CommonConfig.VUE_APP_LABEL,

    url: AppEnvironmentConfig.VUE_APP_PHP_API_BASE_PATH,
    netUrl: AppEnvironmentConfig.VUE_APP_DOTNET_API_BASE_PATH,
    mfaUrl: AppEnvironmentConfig.VUE_APP_OTP_SERVICE_BASE_PATH,
    laUrl: AppEnvironmentConfig.VUE_APP_LA_API_BASE_PATH,
    usUrl: AppEnvironmentConfig.VUE_APP_USERSTATUS_API_BASE_PATH,
    netUrlExchangePath: AppEnvironmentConfig.VUE_APP_DOTNET_API_BASE_PATH + CommonConfig.VUE_APP_DOTNET_API_EXCHANGE_BASE_PATH,

    service: { // часть имени web сервиса для универсального обмена справочников https://sfs:8443/mrs-adm-poh-...
      level: 'level',
      object: 'object',
      propertyType: 'property-type',
      competitor: 'competitor',
      dobd: 'dobd',
      pollQuests: 'poll-quests',
      shopEmployeePosition: 'shop-employee-position',
      specialization: 'specialization',
      pollTemplates: 'poll-templates',
      deactivationReason: 'deactivation-reason',
      employees: 'employees',
      employeeEmployments: 'employee-employments',
      regShopEmployees: 'reg-shop-employees',
      appVersions: 'app-versions',
      shops: 'shops',
      staffs: 'staff',
      staffPosition: 'staff-position',
      accounts: 'accounts',
      reports: 'reports',
      account: 'account',
      programs: 'programs',
      programStatus: 'program-status',
      pollTemplateActions: 'poll-template-actions',
      pollsRunProgram: 'polls-run-program',
      removePollsRunProgram: 'remove-polls-run-program',
      programList: 'program-list',
      reportList: 'report-list',
      cities: 'cities',
      emailTemplate: 'mail-template',
      emailSignatureTemplate: 'email-signature-template',
      property: 'property',
      propertyByDataType: 'property-by-data-type',
      questionProperty: 'question-property',
      questionAnswers: 'question-answers',
      questionAnswersByQuestionId: 'answers-by-question-id',
      questionPropertyByQuestionId: 'question-property-by-question-id',
      visitType: 'visit-type',
      exhibition: 'exhibition',
      dataType: 'data-type',
      dashboardIndex: 'dashboard-index',
      accountAppVersion: 'account-app-version',
      countries: 'countries',
      regions: 'regions',
      checkApiKey: 'check-api-key',
      appSettings: 'appsettings',
      POSM: 'posm-templates',
      templatesSms: 'templates-sms'
    },
  },
  getters: {
    rootUrl(state) {
      return state.url;
    },
    async remoteAppConfig() {
      let pseudoLocalConfig = await fetch(document.domain + '/appconfig.json');
      return pseudoLocalConfig.json();
    },
    netUrl(state) {
      return state.netUrl;
    },
    mfaUrl(state) {
      return state.mfaUrl;
    },
    laUrl(state) {
      return state.laUrl;
    },
    usUrl(state) {
      return state.usUrl;
    },
    netUrlExchangePath(state) {
      return state.netUrlExchangePath;
    },
    service(state) {
      return state.service;
    },
  },
  mutations: {
    async trackAuth(state) {
      await this.$store.dispatch('ifAuth');
    }
  },
  methods: {
    ifAuth() {
      this.$store.commit('ifAuth');
    },
  },
  actions: {
    async ifAuth(to, from, next) {
      let dd = store.getters['auth/isAuth'];

      console.debug('Checking auth validity upon data refresh');

      if (typeof localStorage.apiToken != 'undefined' && paths.path !== '/login') {
        let isValidApiKey = await store.dispatch('auth/isValidApiKey');
        console.debug(isValidApiKey)
      } else if (typeof localStorage.apiToken == 'undefined' || !localStorage.apiToken || (typeof isValidApiKey != 'undefined' && !isValidApiKey) || !store.getters['auth/isAuth']) {
        if (window.getApp !== null && typeof (window.getApp) !== 'undefined') {
          localStorage.removeItem('fullName');
          localStorage.removeItem('lastVisitedPage');
          localStorage.removeItem('apiToken');
          localStorage.removeItem('authToken');

          event.supressionFlag = true;

          window.getApp.$emit('APP_AUTH_CHECK_FAILED');
        }

        setTimeout(() => { paths.push('/login') }, 1000);
      }
    }
  },
  modules: {
    auth: Auth,
    role: Role,
    staff: Staff,
    staffPosition: StaffPosition,
    employees: Employees,
    employeeEmployments: EmployeeEmployments,
    appVersions: AppVersions,
    clinics: Clinics,
    visit: Visit,
    log: Log,
    level: Level,
    object: Object,
    loading: Loading,
    kpi: Kpi,
    propertyType: PropertyType,
    deactivationReason: DeactivationReason,
    specialization: Specialization,
    shopEmployeePosition: ShopEmployeePosition,
    logServer: LogServer,
    pollQuests: PollQuests,
    pollTemplates: PollTemplates,
    report: Report,
    competitor: Competitor,
    dobd: Dobd,
    account: Account,
    programs: Programs,
    programStatus: ProgramStatus,
    pollTemplateActions: PollTemplateActions,
    pollsRunProgram: PollsRunProgram,
    programList: ProgramList,
    cities: Cities,
    emailTemplate: EmailTemplate,
    emailSignatureTemplate: EmailSignatureTemplate,
    property: Property,
    questionProperty: QuestionProperty,
    questionAnswers: QuestionAnswers,
    visitType: VisitType,
    exhibition: Exhibition,
    dataType: DataType,
    dashboard: Dashboard,
    accountAppVersion: AccountAppVersion,
    countries: Countries,
    regions: Regions,
    appsettings: AppSettings,
    posm: POSM,
    templatesSms: TemplatesSms,
    logging: Logging,
    userStatus: UserStatus
  },
});

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js